import { useCallback, useEffect, useRef, useState } from 'react';

/** `ResizeObserver` — в lib TypeScript проекта его ещё нет. */
interface IResizeObserverLike {
  observe: (target: Element) => void;
  disconnect: () => void;
}
type ResizeObserverCtor = new (callback: () => void) => IResizeObserverLike;

const resizeObserverCtor = (): ResizeObserverCtor | undefined =>
  ((window as unknown) as { ResizeObserver?: ResizeObserverCtor })
    .ResizeObserver;

/**
 * Ширина элемента в px (0 — пока не измерен или нет `ResizeObserver`, как в
 * jsdom). Для раскладок, которые зависят от ширины КОЛОНКИ, а не окна:
 * панель треда коммуникатора узкая и на широком мониторе, если открыты
 * обе левые колонки. Ref — колбэк: элемент может появиться позже.
 */
export const useElementWidth = <T extends HTMLElement>(): [
  (node: T | null) => void,
  number,
] => {
  const [width, setWidth] = useState(0);
  const observer = useRef<IResizeObserverLike | null>(null);

  const ref = useCallback((node: T | null) => {
    observer.current?.disconnect();
    observer.current = null;
    if (!node) return;
    const measure = () => setWidth(Math.round(node.clientWidth));
    measure();
    const Observer = resizeObserverCtor();
    if (!Observer) return;
    observer.current = new Observer(measure);
    observer.current.observe(node);
  }, []);

  useEffect(() => () => observer.current?.disconnect(), []);

  return [ref, width];
};
